module.exports = __webpack_public_path__ + "static/media/NotoSansCJKtc-Regular.68d27ac7.ttf";